import { AddCircleOutline } from '@mui/icons-material'
import { Button, Card, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSafePush } from '@omnea-app/fe-routing/useSafePush'
import { DashboardTableType } from './types'

function NoRequestsAvailable({
  showNewRequestButton = false,
  type,
}: {
  showNewRequestButton?: boolean
  type: DashboardTableType
}) {
  const { t } = useTranslation('dashboard')
  const { safeUrlPush } = useSafePush()
  const handleCreateNewClick = () => safeUrlPush('/start')

  return (
    <Card sx={{ width: '100%', py: 15 }}>
      <Stack gap={5} alignItems="center">
        <Typography variant="body-medium" color="text.secondary">
          {t(`request-section.no-active-${type}`)}
        </Typography>
        {showNewRequestButton && (
          <Button variant="outlined" color="primary" startIcon={<AddCircleOutline />} onClick={() => handleCreateNewClick()}>
            {t('request-section.new-request')}
          </Button>
        )}
      </Stack>
    </Card>
  )
}

export { NoRequestsAvailable }
